import { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link, useParams, useHistory, useLocation } from "react-router-dom";
import { scroller } from "react-scroll";
import logoHeader from "../../assets/logo.png";
import { buildRouteWithUtms } from "../../config/whatsappConfig";
import { useWhatsAppConsulta } from "../../config/WhatsAppConsultaContext";
import useFinanciaciones from "../../config/useFinanciaciones";
import { handleStaticLandingCapture } from "../../utils/staticLandings";

const NAV_ITEMS = [
  { label: "Inicio", sectionId: "inicio", route: "/todos" },
  { label: "Venta Directa", sectionId: "convencional", route: "/convencional" },
  { label: "Financiaciones", sectionId: "financiaciones", route: "/convencional" },
];

const Header = () => {
  const { openConsultaForm } = useWhatsAppConsulta();
  const { financiaciones, loading: loadingFinanciaciones } = useFinanciaciones();

  const navItems = NAV_ITEMS.filter(
    (item) => item.sectionId !== "financiaciones" || (!loadingFinanciaciones && financiaciones.length > 0),
  );
  const location = useLocation();
  const history = useHistory();
  const { tipo } = useParams();

  useEffect(() => {
    if (handleStaticLandingCapture(tipo, location.search)) return;
    if (tipo === "plan") {
      history.replace(buildRouteWithUtms("/convencional", location.search));
      return;
    }
    if (tipo !== "todos" && tipo !== "convencional" && tipo !== undefined) {
      history.push(buildRouteWithUtms("/todos", location.search));
    }
  }, []);

  const handleNavClick = ({ sectionId, route }) => {
    const search = location.search;
    const currentTipo = tipo || "todos";
    const targetTipo = route.replace("/", "") || "todos";

    if (currentTipo !== targetTipo) {
      history.push(buildRouteWithUtms(route, search));
    }

    setTimeout(
      () => {
        scroller.scrollTo(sectionId, { smooth: true, duration: 500, offset: -10 });
      },
      currentTipo !== targetTipo ? 350 : 0,
    );
  };

  return (
    <Container fluid className="header">
      <Container>
        <Row className="row-header align-items-center">
          <Col md={4} xs={12} className="text-sm-start text-center">
            <Link to={buildRouteWithUtms("/todos", location.search)}>
              <img src={logoHeader} alt="Montironi GAC" className="header-logo" />
            </Link>
          </Col>
          <Col
            md={8}
            xs={12}
            className="d-md-flex d-none justify-content-md-end align-items-center gap-3 pt-2"
          >
            <nav className="header-nav d-flex align-items-center gap-3">
              {navItems.map((item) => (
                <button
                  key={item.sectionId}
                  type="button"
                  className="link-header"
                  onClick={() => handleNavClick(item)}
                >
                  {item.label}
                </button>
              ))}
            </nav>
            <Button
              className="btn-gac-corporate"
              onClick={() => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ event: "solicitud_presupuesto" });
                openConsultaForm();
              }}
            >
              Solicitar cotización
            </Button>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Header;
